import { useQuery } from "react-query";
import axios from "axios";

const getTags = async ({
  visibility,
  companyIds,
  includeParentChildTags,
  isLinkedToCompany,
  tagType,
}) => {
  let pathAndHost = window.location.protocol + window.location.host;

  let url = new URL(`/api/v2/tags`, pathAndHost);

  if (visibility) {
    url.searchParams.append("visibility", visibility.join(","));
  }

  if (companyIds && companyIds.length > 0) {
    url.searchParams.append("company_ids", companyIds.join(","));
  }

  if (includeParentChildTags !== undefined) {
    url.searchParams.append(
      "include_parent_child_tags",
      includeParentChildTags
    );
  }

  if (isLinkedToCompany !== undefined) {
    url.searchParams.append("is_linked_to_company", isLinkedToCompany);
  }

  if (tagType !== undefined) {
    url.searchParams.append("tag_type", tagType);
  }


  const { data: tags } = await axios.get(url.href);

  return tags;
};
export default function useTags({
  visibility,
  companyIds,
  includeParentChildTags,
  isLinkedToCompany,
  isEnabled,
  tagType,
}) {
  return useQuery(
    [
      "tags",
      {
        visibility,
        companyIds,
        includeParentChildTags,
        isLinkedToCompany,
        tagType,
      },
    ],
    () =>
      getTags({
        visibility,
        companyIds,
        includeParentChildTags,
        isLinkedToCompany,
        tagType,
      }),
    { enabled: isEnabled }
  );
}
